import { Gondor } from "../Gondor";

const ACTIONS = {
  DEBT: "/debt/",
  DEBT_ITEM: "/debt/{id}/",
  ADD_SYSTEMS: "/debt/add/system",
  REMOVE_SYSTEMS: "/debt/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.DEBT, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.DEBT_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.DEBT, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.DEBT_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.DEBT_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
